import moment from 'moment';

export function maxDateTimeAllow(): moment.Moment {
  return moment().add(12, 'months').subtract(1, 'day');
}
